module.exports = __webpack_public_path__ + "static/media/request-session-wallet-balance-icon.d5491710.svg";